import { Checkbox } from "modules/shared/widgets/checkbox";
import { FormConfiguration } from "../shared/crud/form";
import { CampingMapEntity, UnitSelectionModeEnum } from "./infraestructure/campingMap.dto";
import { campingMapMessages } from "./messages";
import AccommodationConfigWidget from "./widgets/AccommodationConfigWidget";

export function buildSchema() {
  return {
    type: "object",
    properties: {
      enabled: { type: "boolean" },
      baseUrl: { type: "string" },
      selectionMode: { type: "string", enum: Object.values(UnitSelectionModeEnum) },
      chargeSelection: { type: "boolean" },
      selectionExpirationMinutes: { type: "integer", minimum: 0 },
      accommodationConfig: { type: "object" },
    },
    required: ["enabled", "selectionMode", "chargeSelection", "selectionExpirationMinutes"],
  };
}

export function buildFormConfiguration(): FormConfiguration<CampingMapEntity> {
  const schema = buildSchema();

  return {
    __fieldOrder: [
      "enabled",
      "baseUrl",
      "selectionMode",
      "chargeSelection",
      "selectionExpirationMinutes",
      "accommodationConfig",
    ],
    enabled: {
      widget: Checkbox,
      messages: { label: campingMapMessages.enabledLabel },
    },
    baseUrl: {
      messages: { label: campingMapMessages.baseUrlLabel },
    },
    selectionMode: {
      messages: { label: campingMapMessages.selectionModeLabel },
      enumLabels: schema.properties.selectionMode.enum.map(it => campingMapMessages[it]),
      default: UnitSelectionModeEnum.OPTIONAL,
      hidden: true, // Hidden for now, as it is not used in the UI
    },
    chargeSelection: {
      widget: Checkbox,
      messages: { label: campingMapMessages.chargeSelectionLabel },
      default: false,
      hidden: true, // Hidden for now, as it is not used in the UI
    },
    selectionExpirationMinutes: {
      messages: { label: campingMapMessages.selectionExpirationMinutesLabel },
      default: 15,
      hidden: true, // Hidden for now, as it is not used in the UI
    },
    accommodationConfig: {
      fieldWidget: AccommodationConfigWidget,
      messages: {
        label: campingMapMessages.accommodationConfigLabel,
      },
    },
  };
}
